import { ViewModel,View } from "binder"
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { ListView } from "./list-view"

export class ListViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ListView();
    }
    public getTypeId(): string {
        return "VM-1303FDE2-E3E1-409F-85F4-C715F3DF84AF"
    }

    setDefaultValue(defaultValue: any): void {
    }
    getDefaultValue():any {
        return null;
    }

}
